module.exports = __webpack_public_path__ + "Fowl.fb2079e.glb";